import React from "react";
import { Route } from "react-router-dom";
import { setLocalSessionData } from "../utils/Authentication/handleUserSession";
import { LOCALSESSIONDATAKEYS } from "../constants/AppConstants";
import CSAgentLayout from "../Layouts/CSAgentLayout";

const C4CCSAgentUnProtectedRoutes = ({ component: Component, ...rest }) => {
    setLocalSessionData(LOCALSESSIONDATAKEYS.ISC4CSERVICEAGENT, true);
    return (
        <Route {...rest} render={props => {
            // authorised so return component
            return(
                <CSAgentLayout>
                    <Component {...props} />
                </CSAgentLayout>
            );
        }} />
    )
}

export default C4CCSAgentUnProtectedRoutes;